<template>
  <div class="flex items-center flex-wrap w-full sm:justify-end justify-start">
    <input v-model="searchString" placeholder="Start Typing Location..." class="p-2 pl-3 w-full sm:w-64 input_field" />
    &nbsp;&nbsp;&nbsp;
    <div class="my-1 sm:hidden block w-full"></div>
    <base-button
     text="Search" 
     :loading="false" 
     class="sm:w-auto"
     @click="$emit('getSearchString', searchString)" 
    />
  </div>
</template>

<script>
export default {
  props: {
    filterFunction: { type: Function },
  },
  data() {
    return {
      searchString: "",
      options: ["All Shipments"],
      filter: {
        type: "",
        startDate: "",
        endDate: "",
      },
      startTime: "",
      endTime: "",
      loading: false,
      filteredData: [],
    };
  },
  watch: {
    "filter.startDate"(val) {
      // alert(val);
      this.startTime = new Date(val + "T00:00:00.000").getTime();
    },
    "filter.endDate"(val) {
      // alert(val);
      this.endTime = new Date(val + "T23:59:59.000").getTime();
    },
  },
  methods: {
    async getBookingsByDate() {
      this.loading = true;
      this.$emit("filtering", this.loading);
      try {
        const response = await this.$_getUserBookingByDate(
          this.startTime,
          this.endTime
        );
        this.log(response);
        this.filteredData = response.data.data.shippings;
        this.$emit("filtered", this.filteredData);
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
      this.$emit("filtering", this.loading);
    },
    async filter_callback() {
      this.$emit("filtering", true);
      this.$emit("need-function", {
        startTime: this.startTime,
        endTime: this.endTime,
      });
      try {
        this.filteredData = await this.$on("need-function-ex");
        this.$emit("filtering", false);
        this.$emit("filtered", this.filteredData);
      } catch (e) {
        this.$emit("filtering", false);
        this.handleError(e);
      }
    },
  },
};
</script>

<style scoped>
.el-select,

.input_field {
  margin-right: 0px;
}
@media screen and (min-width: 768px) {
  .input_field {
     margin-right: 16px;
  }
}


</style>
